module.exports = __webpack_public_path__ + "img/4.009cc199.svg";